import React, { useState } from 'react';
import styled from 'styled-components';

import LoginRegisterModal from '../auth/LoginRegisterModal';
import useModalState from '../../utils/useModalState';
import {
  AUTH_LOGIN_UI,
  AUTH_SIGNUP_UI,
} from '../auth/local-auth/local-auth.constants';
import { trackSignUpClick } from '../tracking/onboarding.tracking';

const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
const StyledLink = styled.a`
  background-color: rgb(0, 0, 0, 0);
  border: 2px solid #b08217;
  border-radius: 8px;
  color: #b08217;
  font-size: 12px;
  font-weight: 300;
  height: 33px !important;
  margin: -2px 0 0 32px;
  max-height: 33px !important;
  min-height: 33px !important;
  max-width: 94px !important;
  text-align: center;
  padding: 5px 12px 4px 12px;

  &:hover {
    color: #b08217;
    text-decoration: none;
  }

  @media (max-width: 991px) {
    margin: 32px 0;
  }
`;
const LoginRegisterLinks = () => {
  const [Modal, isOpen, show, hide] = useModalState(LoginRegisterModal);
  const [initialUI, setInitialUI] = useState(true);
  const handleSignup = () => {
    setInitialUI(AUTH_SIGNUP_UI);
    trackSignUpClick();
    show();
  };
  const handleLogin = () => {
    setInitialUI(AUTH_LOGIN_UI);
    show();
  };
  return (
    <StyledDiv>
      <Modal
        isOpen={isOpen}
        onHide={hide}
        redirectURL={window.location}
        initialUI={initialUI}
      />
      <a href='#' className='nav-link' onClick={handleLogin}>
        Login
      </a>
      <StyledLink href='#' onClick={handleSignup}>
        Signup
      </StyledLink>
    </StyledDiv>
  );
};
export default LoginRegisterLinks;
